import React from 'react';
import { HiOutlineMail } from 'react-icons/hi';
import PropTypes from 'prop-types';
import FormInput from 'partial/form/FormInput';
import Button from 'partial/components/Button';
import Form from 'partial/form/Form';
import { useForgotPassword } from '../hooks';

function ForgotPasswordModal({ email, onClose }) {
  const [form, setForm] = React.useState({
    email: email || '',
  });

  const [isLoading, submit] = useForgotPassword();

  const handleSubmit = () => {
    submit(form, () => {
      onClose();
    });
  };
  // const handleVerifyNumber = (e) => {
  //   e.preventDefault();
  //   setIsNumberVerified(true);
  // };
  // const handleResetPassword = (e) => {
  //   e.preventDefault();
  //   toastSuccess('Your password is updated!');
  //   onClose();
  // };
  // const handleResend = (e) => {
  //   e.preventDefault();
  //   console.log('resend otp!');
  // };
  // React.useEffect(() => {
  //   if (form.otp.length > 5) {
  //     console.log('submit 2', form);
  //     setTimeout(() => {
  //       setisOTPVerified(true);
  //     }, 1000);
  //   }
  // }, [form.otp])
  // if (isOTPVerified) {
  //   return (
  //     <form className="p-3" onSubmit={handleResetPassword}>
  //       <div className="mb-2">
  //         <FormInput
  //           name="password"
  //           label="New Password"
  //           onChange={setResetPwForm}
  //           value={resetPwForm.password}
  //           autoFocus
  //           type="password"
  //         />
  //       </div>
  //       <div className="mb-2">
  //         <FormInput
  //           name="password_confirmation"
  //           label="New Password Confirmation"
  //           onChange={setResetPwForm}
  //           value={resetPwForm.password_confirmation}
  //           type="password"
  //         />
  //       </div>
  //       <div className="flex gap-2">
  //         <button className="primary w-full rounded-lg2" type="submit">
  //           Reset Password
  //         </button>
  //       </div>
  //     </form>
  //   );
  // }
  return (
    <Form onSubmit={handleSubmit}>
      <>
        <div className="mb-2">
          <p className="text-gray-500 mb-3">
            Enter your registered email below to receive password reset
            instructions.
          </p>
          <FormInput
            name="email"
            label="Please enter your email address"
            onChange={setForm}
            value={form.email}
            type="email"
            icon={HiOutlineMail}
            required
          />
        </div>
        <div className="flex gap-2 mt-2 text-sm justify-end">
          <Button onClick={onClose}>Close</Button>
          <Button primary type="submit" disabled={isLoading}>
            Send Instructions
          </Button>
        </div>
      </>
    </Form>
  );
}

ForgotPasswordModal.defaultProps = {
  email: '',
};

ForgotPasswordModal.propTypes = {
  email: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default ForgotPasswordModal;
